import React from 'react';
import DocsSubGridItems from './DocsSubGridItems';

function DocsSubGrid({ toggleGrid, subGridItems, patientId, handleReload }) {
  return (
    <div className={toggleGrid ? 'child-bdy-sec' : 'hide'}>
      <div className="docMaingrid-Pat-sbhdr doc-child-hdr flex-sec">
        <span className="colm1">Doc Name</span>
        <span className="colm1">Type</span>
        <span className="colm2">Date</span>
        <span className="colm5">Status</span>
        <span className="colm4">Action</span>
        <span className="colm1">Reviewer</span>
        <span className="colm3 note-col">Note</span>
        <span className="colm3">Pages</span>
        <span className="colm1">Allocated to</span>
        <span className="colm1">Provider</span>
        <span className="colm2">Added</span>
      </div>
      <div className="grid-sec">
        {subGridItems &&
          subGridItems.map((item, i) => (
            <DocsSubGridItems
              key={i}
              item={item}
              index={i}
              patientId={patientId}
              handleReload={handleReload}
            />
          ))}
      </div>
    </div>
  );
}

export default DocsSubGrid;
